var Basket = /** @class */ (function () {
    function Basket(id, apprenticeships, bespoke, regulated, functionalSkills, organisationName, requesteeName, customerEmail) {
        this.id = id;
        this.apprenticeships = apprenticeships;
        this.bespoke = bespoke;
        this.regulated = regulated;
        this.functionalSkills = functionalSkills;
        this.organisationName = organisationName;
        this.requesteeName = requesteeName;
        this.customerEmail = customerEmail;
    }
    return Basket;
}());
export { Basket };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFza2V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYmFza2V0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtBO0lBQ0ksZ0JBQ1csRUFBVSxFQUNWLGVBQTBDLEVBQzFDLE9BQTJCLEVBQzNCLFNBQStCLEVBQy9CLGdCQUEwQyxFQUMxQyxnQkFBd0IsRUFDeEIsYUFBcUIsRUFDckIsYUFBcUI7UUFQckIsT0FBRSxHQUFGLEVBQUUsQ0FBUTtRQUNWLG9CQUFlLEdBQWYsZUFBZSxDQUEyQjtRQUMxQyxZQUFPLEdBQVAsT0FBTyxDQUFvQjtRQUMzQixjQUFTLEdBQVQsU0FBUyxDQUFzQjtRQUMvQixxQkFBZ0IsR0FBaEIsZ0JBQWdCLENBQTBCO1FBQzFDLHFCQUFnQixHQUFoQixnQkFBZ0IsQ0FBUTtRQUN4QixrQkFBYSxHQUFiLGFBQWEsQ0FBUTtRQUNyQixrQkFBYSxHQUFiLGFBQWEsQ0FBUTtJQUM1QixDQUFDO0lBQ1QsYUFBQztBQUFELENBQUMsQUFYRCxJQVdDIn0=